export default __webpack_public_path__ + "static/media/1899.358d316b.png";